import {ApolloClient} from 'apollo-client'
import {HttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import {ApolloLink} from 'apollo-link'
const apiLink = new HttpLink({
    uri: 'https://api.xiaoyima.work/screenInfo'    //请求路径生产
   })
  // const apiLink = new HttpLink({
  //   uri: 'http://192.168.80.128:9501/screenInfo'    //请求路径
  // })
  
  //配置请求头
  const middlewareLink = new ApolloLink((operation, forward) => {
    const token = sessionStorage.getItem('Authorization')
    // const token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzeiIsImlhdCI6MTYwNzUwMTY1NywiZXhwIjoxNjA3NTA4ODU3LCJuYmYiOjE2MDc1MDE3MTcsInN1YiI6InN6X3VzZXJzIiwianRpIjoyNzQwfQ.cOBG2bVmzLw9dZw4GIWoc3iM8zpT2vAPKEEido-CjiQ"
    operation.setContext({
      headers: {
        Authorization: token
      }
    })
    return forward(operation)
  })
  
  const apiClient = new ApolloClient({
    link: middlewareLink.concat(apiLink),  //如果不添加请求头直接放路径
    cache: new InMemoryCache()
  })

  
  export default apiClient



// WEBPACK FOOTER //
// ./src/utils/graphql/graphql.js